export default "__VITE_PUBLIC_ASSET__44c9c2f7__"